import { dark as theme } from 'mdx-deck/themes'

import { code, header } from './fonts'
import colors from './colors'
import codeTheme from './main-code-theme'

export * from './slides'

export default {
  ...theme,
  font: header.join(','),
  monospace: code.join(','),
  transitionTimingFunction: 'linear',
  transitionDuration: '0s',
  colors: {
    background: 'white',
    heading: colors.main
  },
  blockquote: {
    color: colors.secondary,
    paddingLeft: '2rem',
    borderLeft: `5px solid ${colors.main}`
  },

  h1: {
    fontSize: '3.6rem',
    marginBottom: '10px'
  },

  h2: {
    fontSize: '3.2rem',
    marginBottom: '8px',
    marginTop: '0'
  },

  h3: {
    fontSize: '2.8rem',
    marginBottom: '6px'
  },

  h4: {
    fontSize: '2.6rem',
    marginBottom: '4px'
  },

  h5: {
    fontSize: '2.3rem',
    marginBottom: '2px'
  },

  p: {
    fontSize: '2rem',
    margin: '10px 0'
  },
  paragraph: {
    color: colors.main
  },
  li: {
    color: colors.secondary
  },
  prism: {
    style: codeTheme
  }
}
